<script lang="ts" setup>
const { data: userInfo } = useAuth()
const maxExp = computed(
  () =>
    levelSection.find(
      (item) => item.level_id === (userInfo.value?.user.level_id || 0) + 1
    )?.experience || 1
)
const { data } = useAsyncData('userFollowAndFans', () =>
  fetchUserFollowAndFansById(userInfo.value?.user.id || 0)
)
const percentage = computed(() => {
  return Number(
    (((userInfo.value?.user.exp || 0) / maxExp.value) * 100).toFixed(2)
  )
})

const levelSection = [
  {
    id: 10,
    experience: 50000,
    level_id: 10,
    badges_id: 10
  },
  {
    id: 9,
    experience: 16000,
    level_id: 9,
    badges_id: 9
  },
  {
    id: 8,
    experience: 7500,
    level_id: 8,
    badges_id: 8
  },
  {
    id: 7,
    experience: 4000,
    level_id: 7,
    badges_id: 7
  },
  {
    id: 6,
    experience: 1800,
    level_id: 6,
    badges_id: 6
  },
  {
    id: 5,
    experience: 900,
    level_id: 5,
    badges_id: 5
  },
  {
    id: 4,
    experience: 500,
    level_id: 4,
    badges_id: 4
  },
  {
    id: 3,
    experience: 200,
    level_id: 3,
    badges_id: 3
  },
  {
    id: 2,
    experience: 50,
    level_id: 2,
    badges_id: 2
  },
  {
    id: 1,
    experience: 1,
    level_id: 1,
    badges_id: 1
  }
]
</script>

<template>
  <div v-if="userInfo?.user" class="m-user-panel">
    <div class="m-user-panel__user">
      <user-avatar
        :user-id="userInfo.user.id"
        :src="userInfo.user.avatar"
        class="m-user-panel__avatar"
        size="lg"
        :auth="userInfo.user.user_auth"
        disable-jump
      />
      <div class="m-user-panel__info">
        <div class="m-user-panel__name">{{ userInfo.user.name }}</div>
        <m-badge
          :badges="[userInfo.user.level_badge, ...userInfo.user.badges]"
        />
      </div>
    </div>
    <div class="m-user-panel__follow">
      <div>
        <span>{{ data?.follow || 0 }}</span>
        <span>关注</span>
      </div>
      <div>
        <span>{{ data?.fans || 0 }}</span>
        <span>粉丝</span>
      </div>
    </div>
    <div class="m-user-panel__exp">
      <n-progress
        type="line"
        :percentage="percentage"
        :show-indicator="false"
      />
      <span tertiary>{{ userInfo.user.exp }}/{{ maxExp }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-user-panel {
  width: 256px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &__user {
    width: 100%;
    display: flex;
  }
  &__info {
    flex: 1;
    width: 0;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  &__name {
    font-size: 18px;
    font-weight: 600;
    color: var(--color-gray-800);
    cursor: default;
  }
  &__follow {
    display: flex;
    width: 100%;
    justify-content: space-around;
    cursor: default;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      > span:first-child {
        font-size: 18px;
        color: var(--color-gray-800);
      }
      > span:last-child {
        color: var(--color-gray-400);
        font-size: 12px;
      }
    }
  }
  &__exp {
    width: 100%;
    display: flex;
    align-items: center;
    > span {
      color: var(--color-gray-400);
      font-size: 12px;
      margin-left: 12px;
    }
  }
}
</style>
